export default {"src":"/_next/static/media/ico-blaze.f6112ecd.svg","height":144,"width":270,"blurWidth":0,"blurHeight":0};